 /**
 * Created by arto on 4.4.2018.
 */

const state = {
    devices: []
}

const getters = {
    devices: state => state.devices
}

const actions = {
    getDeviceData({commit, state}, deviceId) {

    },
    getDeviceById({commit, state}, deviceId) {
        return state.devices.filter(device  => device.id === deviceId);
    }
}

const mutations = {
    addDevice(state, device) {
        state.devices.push(device);
    },
    removeDevice(state, deviceId) {
        state.devices = state.devices.filter(device => device.id !== deviceId);
    },
    clearDevices(state) {
        state.devices = [];
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/app/store/modules/devices.js